/**
 * StandOut WordPress Theme
 * Theme-wide functionality initialization
 *
 * @package StandOut
 * @since 2.0.0
 */
import { onDomReady } from "@utils/dom-ready";
import { initCookieConsent } from "./cookie-consent";
import { initFooter } from "./footer";
import { initHeaderSearch } from "./header-search";
import { initLanguageSwitcher } from "./language-switcher";
import { initNavDropdown } from "./nav-dropdown";
import { initNotificationBar } from "./notification-bar";
import { initSiteMenu } from "./site-menu";
onDomReady(() => {
    initSiteMenu();
    initHeaderSearch();
    initNavDropdown();
    initLanguageSwitcher();
    initFooter();
    initNotificationBar();
    initCookieConsent();
});
